import React from 'react';
import { CTAButton } from './CTAButton';
export function AuthorSection() {
  return <section className="bg-cream-light py-[100px] px-5" data-id="element-22">
      <div className="max-w-[760px] mx-auto" data-id="element-23">
        <div className="text-center mb-12" data-id="element-24">
          <p className="font-sans text-[11px] font-bold tracking-[0.3em] text-gold-accent uppercase mb-4" data-id="element-25">
            THE ENGINEER BEHIND THE SYSTEM
          </p>
          <h2 className="font-serif text-[32px] md:text-[40px] text-primary-dark leading-tight" data-id="element-26">
            I Am Roderic, an Engineer.
          </h2>
        </div>

        {/* Author portrait */}
        <div className="flex justify-center mb-12" data-id="element-27">
          <div className="w-[180px] h-[180px] md:w-[220px] md:h-[220px] rounded-full overflow-hidden border-[4px] border-gold-accent/30 shadow-[0_8px_30px_rgba(0,0,0,0.12)]" data-id="element-28">
            <img src="https://cdn.magicpatterns.com/uploads/5HnACv1XGYAG5895SW9LUJ/heylloyd-image-1774830595029.png" alt="Roderic — Engineer & Founder of GoDeskCore / PROSPERA" className="w-full h-full object-cover object-top" data-id="element-29" />
          </div>
        </div>

        <div className="font-sans text-[18px] text-primary-dark leading-[2] mb-12" data-id="element-30">
          <p className="mb-6" data-id="element-31">
            Three years ago, a six-coronary bypass changed my life. I survived,
            but I spent 12 months in recovery. During that time, the world
            didn't pause. My stable life was hit by $40,000 in medical debt,
            insurance gaps, and a mountain of household bills.
          </p>
        </div>

        {/* The Failure */}
        <div className="mb-10 pl-6 border-l-[4px] border-blood-red/40" data-id="element-32">
          <p className="font-sans text-[12px] font-bold tracking-[0.2em] text-blood-red/70 uppercase mb-3" data-id="element-33">
            The Failure
          </p>
          <p className="font-sans text-[18px] text-primary-dark leading-[2]" data-id="element-34">
            I had a career, but no Tactical Framework for a crisis where "what
            goes out" exceeds "what comes in."
          </p>
        </div>

        {/* The Engineering */}
        <div className="mb-10 pl-6 border-l-[4px] border-gold-accent" data-id="element-35">
          <p className="font-sans text-[12px] font-bold tracking-[0.2em] text-gold-accent uppercase mb-3" data-id="element-36">
            The Engineering
          </p>
          <p className="font-sans text-[18px] text-primary-dark leading-[2]" data-id="element-37">
            I stopped looking for "motivation" and started building a Recovery
            System. I analyzed the debt-collection machinery, stress-tested
            negotiation scripts, and engineered a roadmap to master the math
            that was trying to dominate my family.
          </p>
        </div>

        {/* The Mission */}
        <div className="mb-12 pl-6 border-l-[4px] border-success-green" data-id="element-38">
          <p className="font-sans text-[12px] font-bold tracking-[0.2em] text-success-green uppercase mb-3" data-id="element-39">
            The Mission
          </p>
          <p className="font-sans text-[18px] text-primary-dark leading-[2]" data-id="element-40">
            I've documented this exact Field Manual. It's a tactical gift — for
            a price lower than a single late fee on your credit card. I've been
            where you are, and I engineered the way out.
          </p>
        </div>

        <div className="max-w-[600px] mx-auto text-center mb-12" data-id="element-41">
          <p className="font-serif text-[26px] md:text-[30px] text-primary-dark leading-snug font-bold" data-id="element-42">
            Acquire the math.
            <br data-id="element-43" />
            <span className="italic text-gold-accent" data-id="element-44">Stop the chaos.</span>
          </p>
        </div>

        <div className="text-center mb-10" data-id="element-45">
          <p className="font-sans text-[14px] text-primary-dark/50" data-id="element-46">
            — Roderic · Engineer & Founder, GoDeskCore / PROSPERA
          </p>
        </div>

        <div className="flex justify-center" data-id="element-47">
          <CTAButton subText="Engineered from real debt · Battle-tested in real life" data-id="element-48">
            SHOW ME THE FIELD MANUAL → $9.99
          </CTAButton>
        </div>
      </div>
    </section>;
}